/* External */
import { useEffect } from 'react';

/* Utils */
import { getDeviceId } from '../../../../utils/deviceIdUtils';
import loginDevice from './loginDevice';
import { useIsLoggedIn } from '../../../../providers/UserProvider';

export default function useLoginDevice(registrationCode, country, deviceCode = '') {
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    let stopLoginDevice;

    function callLoginDevice() {
      const deviceId = getDeviceId();
      stopLoginDevice = loginDevice({
        deviceId,
        registrationCode,
        deviceCode,
      });
    }

    if (registrationCode && !isLoggedIn) {
      callLoginDevice();
    }

    return stopLoginDevice;
  }, [registrationCode, isLoggedIn, deviceCode]);

  return isLoggedIn;
}
